
const CSS_CHARTS = "nguvu-charts";
const CSS_CHARTS_DIV = "nguvu-chart-div";
const CSS_CHARTS_DIV_DOUGHNUT = "nguvu-chart-div-doughnut";
const CSS_CHART_SECTION = "nguvu-chart-section";
const CSS_CHART_SPAN = "nguvu-chart-span";
const CSS_CHART_P = "nguvu-chart-p";

const COLORS = ["#E47137", "#EDAF57", "#F5C73E", "#623538", "#204054"];

getElementsByContains = function (tag, contents) {
  // https://jsfiddle.net/gaby_de_wilde/o7bka7Ls/9/
  const elms = document.evaluate(
    `//${tag}[contains(., '${contents}')]`,
    document,
    null,
    XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE,
    null,
  );

  let nodeSet = [];

  for (let i = 0; i < elms.snapshotLength; i++) {
    nodeSet.push(elms.snapshotItem(i));
  }

  return nodeSet;
};

const getSheet = async (id) => {
  const response = await fetch(
    `https://docs.google.com/spreadsheets/d/1gyTjkSfpfd8xnQf_vhesQn6FCCDogHIN9ovvnlm-ldk/gviz/tq?sheet=${id}`,
  );

  const text = await response.text();

  return JSON.parse(
    `{${text.substring(text.lastIndexOf(`"table"`), text.length - 2)}`,
  );
};

const addChart = (id, type, labels, data, node) => {
  node.classList.add(CSS_CHARTS);

  const div = document.createElement("div");
  div.setAttribute("class", CSS_CHARTS_DIV);

  if (type === "doughnut") {
    div.setAttribute("class", CSS_CHARTS_DIV_DOUGHNUT);
  }

  const span = document.createElement("span");
  span.setAttribute("class", CSS_CHART_SPAN);
  span.innerText = id;

  const canvas = document.createElement("canvas");
  canvas.setAttribute("id", id);

  div.appendChild(span);
  div.appendChild(canvas);

  const formatter = new Intl.NumberFormat();

  if (true) {
    let i = 0;

    const section = document.createElement("section");
    section.setAttribute("class", CSS_CHART_SECTION);

    labels.forEach((label, index) => {
      const p = document.createElement("p");

      p.setAttribute("class", CSS_CHART_P);
      p.innerHTML = `<strong>${formatter.format(parseFloat(data[index]))}</strong>&nbsp;&nbsp;&nbsp;<em>${label}</em>`;

      const span = document.createElement("span");
      span.setAttribute("style", `background-color: ${COLORS[i]};`);

      p.appendChild(span);

      section.appendChild(p);

      i++;

      if (i >= COLORS.length) {
        i = 0;
      }
    });

    div.appendChild(section);
  }

  node.appendChild(div, node);

  const context = canvas.getContext("2d");

  new Chart(context, {
    type: type,
    data: {
      labels: labels,
      datasets: [
        {
          data: data,
          backgroundColor: type === "line" ? COLORS[4] : COLORS,
          borderWidth: type === "line" ? 1 : 0,
          borderColor: COLORS[4],
          tension: 0.4,
        },
      ],
    },
    options: {
      responsive: false,
      plugins: {
        legend: {
          display: false,
        },
      },
    },
  });
};

document.addEventListener("DOMContentLoaded", async () => {
  try {
    const config = await getSheet("CONFIG");

    const types = config.table.rows[1].c.map((c) => c.v);

    let i = -1;

    config.table.rows[0].c
      .map((c) => c.v)
      .forEach(async (configSheetName) => {
        i++;

        const type = types[i];

        const elements = getElementsByContains("p", "nguvu-charts");

        elements.map(async (e) => {
          const sheets = e.innerText
            .substring(
              e.innerText.lastIndexOf("[") + 1,
              e.innerText.lastIndexOf("]"),
            )
            .split('", "');

          const shouldRender =
            sheets.filter((s) => s.lastIndexOf(configSheetName) !== -1).length >
            0;

          if (shouldRender) {
            const sheet = await getSheet(configSheetName);

            addChart(
              configSheetName,
              type,
              type === "line"
                ? sheet.table.rows[0].c.map((c) => (c && c.v) || 0)
                : sheet.table.cols.map((c) => c.label),
              type === "line"
                ? sheet.table.rows[1].c.map((c) => (c && c.v) || 0)
                : sheet.table.rows[0].c.map((c) => (c && c.v) || 0),
              e,
            );
          }
        });
      });
  } catch (e) {
    console.log(e);
  }
});

function getDiscountValue(discount) {
  let planSelectors = document.querySelectorAll(".paywhirl-plan-selector-group-name");
  if (planSelectors.length > 0) {
    let priceGroup = planSelectors[1].querySelector(".paywhirl-plan-selector-group-price");
    let comparePrice = document.querySelector('.product-price--original');
    if (comparePrice && priceGroup) {
      let comparePriceValue = comparePrice.innerText;
      let priceElem = priceGroup.querySelector('.paywhirl-price');
      if (!priceElem) {
        return 0;
      }
      let price = priceElem.innerText;
      let compare = parseFloat(comparePriceValue.replace(/[^0-9.-]+/g, ""));
      let current = parseFloat(price.replace(/[^0-9.-]+/g, ""));
      if (compare > 0) {
        let percent = ((compare - current) / compare) * 100;
        return percent;
      } else {
        return 0;
      }
    }
  }
  return 0;
}

// Observer to detect when .paywhirl-plan-selector-container appears
function observePaywhirlPlanSelectorContainer(callback) {
  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelector('.paywhirl-plan-selector-group-price')) {
      obs.disconnect();
      callback(document.querySelector('.paywhirl-plan-selector-group-price'));
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}


observePaywhirlPlanSelectorContainer((el) => {
  const discountPercent = getDiscountValue();
  console.log('Discount percent:', discountPercent);

  // Create the discount div
  const discountDiv = document.createElement('div');
  discountDiv.className = 'paywhirl-discount-banner';
  // Format percent to 1 decimal and add %
  const percentText = discountPercent ? discountPercent.toFixed(0).replace('.', ',') + '%' : '';
  discountDiv.innerText = `Spar ${percentText} ved abonnementkøb`;

  // Inject the div after the detected element (el)
  if (el && el.parentNode) {
    el.parentNode.insertBefore(discountDiv, el.nextSibling);
  } else {
    // fallback: append to body if el not found
    document.body.appendChild(discountDiv);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  let announcementBar = document.querySelector('.custom-announcement-bar');
  let siteHeader = document.querySelector('.site-header');
  let siteHeaderHeight = siteHeader.offsetHeight;
  let firstSection = document.querySelector('#main .shopify-section');
  if (announcementBar) {
    let windowScrollY = 0;
    let announcementBarHeight = announcementBar.offsetHeight;
    window.addEventListener('scroll', () => {
      windowScrollY = window.scrollY;
      if (windowScrollY > announcementBarHeight) {
        siteHeader.classList.add('site-header--sticky');
        firstSection.style.marginTop = siteHeaderHeight + 'px';
      } else {
        siteHeader.classList.remove('site-header--sticky');
        firstSection.style.marginTop = '0';
      }
    });
  } else {
    siteHeader.classList.add('site-header--sticky');
    firstSection.style.marginTop = siteHeaderHeight + 'px';
  }
});